import { environment } from '../../../../../../../environments/environment';
import { list } from '../../../../../../common/classes/request-builder';
import { StorageManager } from '../../../../../../common/storage-manager.class';

import { FincasModel } from 'src/app/models/form-common/fincas.module';
import { MaquinariaModel } from 'src/app/models/trabajadores/maquinaria.model';
import { SectorModel } from 'src/app/models/form-common/sector.model';
import { ParcelasModel } from 'src/app/models/form-common/parcelas.model';
import { ProductModel } from 'src/app/models/productos/product.model';
import {
    DropdownData,
    FilteredValue,
    Input,
    InputType,
} from 'src/app/common/components/reactive-form-builder/interfaces/input.interface';
import {
    Form,
    FormField,
    FormFieldConditions,
    FormSection,
    FormType,
} from 'src/app/common/components/reactive-form-builder/interfaces/form.interface';
import { TareaOtraModel } from '../../../../../../models/tareas/tarea-otra.model';

type OtrasFieldMetadata = {
    [key: string]: any;
    field?: string;
    name?: string;
    label?: string;
    inputType?: { type: InputType };
    values?: DropdownData<unknown>;
    required?: boolean;
    visible?: boolean;
    hidden?: boolean;
    filter?: (it: FilteredValue<any>) => boolean;
    valuePrimaryKey?: string;
};

export class OtrasFormDefinition {

    public disabledDates: Date[];
    public formType: FormType = FormType.CREATION;
    public model: Partial<TareaOtraModel> = {};
    public formFieldsReactive!: Form<TareaOtraModel>;
    public fieldNames: FormField<any>[] = [];
    public fieldLabels: string[] = [];
    public rolUser = StorageManager.getUser().rol;
    public hasClients = environment.features.hasClients;
    public fincaName = environment.features.fincaName;
    public fincasName = environment.features.fincasName;
    public showSectores = environment.features.showSectores;
    public sectorName = environment.features.sectorName;
    public sectoresName = environment.features.sectoresName;
    public showParcelas = environment.features.showParcelas;
    public parcelaName = environment.features.parcelaName;
    public parcelasName = environment.features.parcelasName;
    public tipoSuperficieParcelas = environment.features.hasSuperficieCultivada ? 'Sup.\xa0Cultivada' : 'S.\xa0Sigpac';
    public textoSuperficie = environment.features.textoSuperficie;
    public showTareasGenericasObservaciones = environment.features.showTareasGenericasObservaciones;
    public showTareasOtrosDuracion = environment.features.showTareasOtrosDuracion;
    public showTareasOtrasProducto = environment.features.showTareasOtrasProducto;
    public showTareasOtrasCantidad = environment.features.showTareasOtrasCantidad;
    public showTareasOtrasUnidadMedida = environment.features.showTareasOtrasUnidadMedida;
    public showTareasOtrosMultiple = environment.features.showTareasOtrosMultiple;
    public showTareasProcura = environment.features.showTareasProcura;
    public appName = environment.appName;
    public applicationType = environment.features.applicationType;
    public serveUrl = environment.serverUrl;

    public timeStartStopTareas = environment.features.timeStartStopTareas;

    public clientes = list();
    public fincas: DropdownData<FincasModel> = list<FincasModel>();
    public sectores: DropdownData<SectorModel> = list<SectorModel>();
    public parcelas: DropdownData<ParcelasModel> = list<ParcelasModel>();
    public users = list();
    public maquinarias = list();
    public trabajadores = list();
    public tareas = list();
    public productos = list(['...', null]);
    public estadoTarea = list(['...', null], 'Orden de Trabajo', 'Parte de Trabajo');
    public prioridades = list(['...', null], 'Alta', 'Realizada');

    // Para los usuarios de user debes especificar la horas de inicio y fin para el cliente AVA
    public activateRequireHourForRolUser = this.appName === 'ava' ? StorageManager.getUser().rol !== 'admin' ? true : false : false;

    public actividad_agraria = list(['...', null],
        'Producción en Tierras de Cultivo y Cultivos Permanentes',
        'Mantenimiento',
        'Pastoreo',
        'Siega Producción',
        'Sin actividad agraria por razones medioambientales');

    public tareas_maquinaria = list(['...', null],
        'Abonar',
        'Fangueo',
        'Hacer Márgenes',
        'Trailla',
        'Láser',
        'Cultivador',
        'Rotovator',
        'Multiapero',
        'Paquete de trabajo 1',
        'Paquete de trabajo 2');

    public tareas_manuales = list(['...', null],
        'Abrir Boqueras',
        'Bordoma',
        'Transplantar',
        'Escarda',
        'Desbroce Cursos de Agua',
        'Siega Orillas',
        'Quemar Paja',
    );

    public formFieldsLinea1: OtrasFieldMetadata[] = [
        {
            field: 'fecha',
            label: 'Fecha',
            inputType: { type: InputType.CALENDAR },
            calendarConfiguration: {
                calendarView: 'date',
                calendarDateFormat: 'dd/mm/yy',
                disabledDates: [],
                onSelect: (date: Date) => {
                    if (this.appName !== 'detorres') { return; }
                    const matches = this.eventos.filter(e => {
                        const parts = e.start.split('-');
                        if (parts.length !== 3) { return false; }
                        const d = Number(parts[0]);
                        const m = Number(parts[1]);
                        const y = Number(parts[2]);
                        return date.getFullYear() === y && date.getMonth() === m - 1 && date.getDate() === d;
                    });
                    if (matches.length === 0) { return; }
                    const mensaje = matches.map((ev, i) =>
                        `Evento ${i + 1}:\n• Título: ${ev.title}\n• Hora inicio: ${ev.hora_inicio}\n• Hora fin: ${ev.hora_fin}`
                    ).join('\n\n');
                    alert(mensaje);
                }
            },
            required: this.appName !== 'ava'
        },
        {
            field: 'id_tarea',
            label: this.appName === 'detorres'
                ? 'Jardinería'
                : (this.esViveroOGardenGest() ? 'Genéricas' : 'Tareas'),
            inputType: { type: InputType.DROPDOWN_SEARCH },
            values: this.tareas,
            valuePrimaryKey: 'id',
            visible: this.appName !== 'sequiador' && this.appName !== 'SIEX'
        },
        {
            field: 'ids_trabajadores',
            label: 'Trabajadores',
            inputType: { type: InputType.MULTISELECT_SEARCH },
            multiSelect: true,
            values: this.trabajadores,
            valuePrimaryKey: 'id',
            filter: (it: { value: { activo: string; }; }) => {
                if (it.value.activo.toString() !== '1') { return false; }
                return true;
            },
            visible: (this.appName === 'tomega' && this.rolUser !== 'aplicador') || this.appName !== 'tomega'
        },
        {
            field: 'id_maquinaria',
            label: 'Maquinaria',
            inputType: { type: InputType.DROPDOWN_SEARCH },
            values: this.maquinarias,
            valuePrimaryKey: 'id',
            filter: (it: { value: MaquinariaModel }) => {
                if (it.value.activo?.toString() !== '1') { return false; }
                if (this.appName === 'pyf') { return it.value.id_cliente === StorageManager.getClient()?.id; }
                return true;
            }
        },
    ];

    public formFieldsHoras: OtrasFieldMetadata[] = [
        {
            field: 'hora_inicio',
            label: 'Hora Inicio',
            inputType: { type: InputType.TIME },
            visible: this.timeStartStopTareas,
            required: this.activateRequireHourForRolUser || environment.appName === 'agrotata'
        },
        {
            field: 'hora_fin',
            label: 'Hora Fin',
            inputType: { type: InputType.TIME },
            visible: this.timeStartStopTareas,
            required: this.activateRequireHourForRolUser || environment.appName === 'agrotata'
        },
        {
            field: 'horas_totales',
            label: 'Horas Totales',
            inputType: { type: InputType.ONLY_TEXT },
            visible: environment.features.showTareasMto || environment.features.tareasHorasTotales
        },
    ];

    public formFields: OtrasFieldMetadata[] = [
        {
            field: 'id_finca',
            label: this.fincaName,
            inputType: { type: InputType.DROPDOWN_SEARCH },
            values: this.fincas,
            valuePrimaryKey: 'id',
            filter: (it: FilteredValue<FincasModel>) => this.filterFinca(it),
            required: true
        },
        {
            field: 'id_sector',
            label: this.sectorName,
            inputType: {
                type: this.showTareasOtrosMultiple
                    ? InputType.MULTISELECT_SEARCH
                    : InputType.DROPDOWN_SEARCH,
            },
            multiSelect: this.showTareasOtrosMultiple,
            canSelectAll: this.showTareasOtrosMultiple,
            values: this.sectores,
            valuePrimaryKey: 'id',
            filter: (it: FilteredValue<SectorModel>) => this.filterSector(it),
            visible: this.showSectores
        },
        {
            field: 'ids_parcelas',
            label: this.parcelaName,
            inputType: { type: InputType.MULTISELECT_SEARCH },
            values: this.parcelas,
            valuePrimaryKey: 'id',
            multiSelect: true,
            canSelectAll: true,
            filter: (it: FilteredValue<ParcelasModel>) => this.filterParcela(it),
            required: this.appName !== 'pyf',
            visible: this.showParcelas
        },
        {
            field: 'fecha_fin',
            label: 'Fecha Fin',
            inputType: { type: InputType.CALENDAR },
            visible: this.appName === 'fotoagricultura',
        },
        {
            field: 'id_producto',
            label: 'Producto',
            inputType: { type: InputType.DROPDOWN_SEARCH },
            values: this.productos,
            valuePrimaryKey: 'id',
            visible: this.showTareasOtrasProducto,
            filter: (it: FilteredValue<ProductModel>): boolean => {
                if (it.value == null) {
                    return true;
                }

                return this.appName !== 'detorres' || it.value.tipo === 'Jardinería';
            }
        },
        {
            field: 'cantidad',
            label: 'Cantidad',
            inputType: { type: InputType.NUMERIC },
            visible: this.showTareasOtrasCantidad
        },
        {
            field: 'unidad_medida',
            label: 'Unidad de Medida',
            inputType: { type: InputType.DROPDOWN },
            values: list(),
            visible: this.showTareasOtrasUnidadMedida
        },
        {
            field: 'num_albaran',
            label: 'Nº albarán',
            inputType: { type: InputType.TEXT },
            visible: environment.appName === 'pyf'
        },
        {
            field: 'apero',
            label: 'Apero utilizado',
            inputType: { type: InputType.TEXT },
            visible: environment.appName === 'pyf'
        },
        {
            field: 'pastoreo',
            label: 'Pastoreo',
            inputType: { type: InputType.DROPDOWN_SEARCH },
            values: list(['...', null], 'Si', 'No'),
            visible: environment.appName === 'pyf'
        },
        {
            field: 'procura',
            label: 'Procura',
            inputType: { type: InputType.DROPDOWN_SEARCH },
            values: list(['...', null], 'Procura', 'Media procura', 'Libre'),
            visible: this.showTareasProcura
        },
        {
            field: 'obs',
            label: 'Observaciones',
            inputType: { type: InputType.DROPDOWN_SEARCH },
            values: list(['...', null], 'Total', 'Parcial', 'Por bandas'),
            visible: environment.appName === 'pyf'
        },
        {
            field: 'ids_asignados',
            label: 'Asignador',
            inputType: { type: InputType.MULTISELECT },
            multiSelect: true,
            canSelectAll: true,
            valuePrimaryKey: 'id',
            values: this.users,
            visible: (environment.features.showAssignUserTasksFertilizante || environment.features.showAssignUserInAllTasks) &&
                StorageManager.getUser().rol === 'admin',
            required: true
        },
        {
            field: 'horas',
            label: this.appName === 'detorres' ? 'Horas Maquinaria' : 'Horas',
            inputType: {
                type: (this.appName === 'fotoagricultura' || this.appName === 'agropedbel')
                    ? InputType.TEXT
                    : InputType.TIME
            },
            visible: !this.timeStartStopTareas && this.appName !== 'avafitogest'
        },
        {
            field: 'estado_tarea',
            label: 'Estado de la Tarea',
            inputType: { type: InputType.DROPDOWN },
            values: this.estadoTarea,
            visible: this.appName === 'onda' || this.appName === 'lacooperativa'
        },
        {
            field: 'empresa_pagadora',
            label: 'Empresa Pagadora',
            inputType: { type: InputType.TEXT },
            visible: this.appName === 'onda' || this.appName === 'lacooperativa'
        },
        {
            field: 'actividad_agraria',
            label: 'Actividad Agraria',
            inputType: { type: InputType.DROPDOWN },
            values: this.actividad_agraria,
            visible: (this.appName === 'sequiador' || environment.features.activateSIEX) && this.appName !== 'agrotata'
        },
        {
            field: 'tareas_maquinaria',
            label: 'Tareas Maquinaria',
            inputType: { type: InputType.DROPDOWN },
            values: this.tareas_maquinaria,
            visible: (this.appName === 'sequiador' || environment.features.activateSIEX) && this.appName !== 'agrotata'
        },
        {
            field: 'tareas_manuales',
            label: 'Tareas Manuales',
            inputType: { type: InputType.DROPDOWN },
            values: this.tareas_manuales,
            visible: (this.appName === 'sequiador' || environment.features.activateSIEX) && this.appName !== 'agrotata'
        },
        {
            field: 'prioridad',
            label: 'Prioridad',
            inputType: { type: InputType.DROPDOWN },
            values: list(['...', null], 'Alta', 'Media', 'Baja'),
            visible: this.appName === 'ava'
        },
        {
            field: 'aplicado',
            label: 'Aplicado',
            inputType: { type: InputType.DROPDOWN },
            values: list(['...', null], 'Si', 'No'),
            visible: this.appName === 'ava'
        },
        {
            field: 'prioridad',
            label: 'Prioridad/Realizada',
            inputType: { type: InputType.DROPDOWN },
            values: this.prioridades,
            visible: environment.features.showTareasMto
        }
    ];

    public FormFieldsObs: OtrasFieldMetadata[] = [
        {
            field: 'observaciones',
            label: 'Observaciones',
            inputType: { type: InputType.TEXTAREA },
            audio: true,
            visible: this.showTareasGenericasObservaciones
        },
    ];

    
    constructor(
        /** Fechas deshabilitadas (Date[]) */
        disabledDates: Date[],
        /** Eventos con title/hora_inicio/hora_fin */
        private eventos: { start: string; title: string; hora_inicio: string; hora_fin: string }[],
        type: FormType = FormType.CREATION,
        model: Partial<TareaOtraModel> = {},
    ) {
        this.disabledDates = disabledDates;
        this.eventos = eventos;
        this.formType = +type;
        this.model = model;
        this.rebuildReactiveForm();
    }

    public addClientFieldForDuplicate(): void {
        const alreadyExists = this.formFields.some((field) => field.field === 'id_cliente');

        const canSeeClientes = environment.features.userCanSeeClientes || StorageManager.getUser().rol === 'admin';

        if (alreadyExists || !this.hasClients || !canSeeClientes) {
            return;
        }

        if (this.formType !== FormType.DUPLICATION) {
            return;
        }

        this.formFields.unshift({
            field: 'id_cliente',
            label: environment.features.clienteName,
            inputType: { type: InputType.DROPDOWN_SEARCH },
            values: this.clientes,
            valuePrimaryKey: 'id',
            required: true,
        });
        this.rebuildReactiveForm();
    }

    public rebuildReactiveForm(): void {
        this.formFieldsReactive = {
            name: 'tareas-otros',
            header: this.getHeader(),
            type: this.formType,
            sections: this.getReactiveSections(),
            table: null,
            uploadButton: {
                isEnabled: false,
                label: '',
            },
            signed: false,
        };

        this.fieldNames = this.formFieldsReactive.sections
            .filter((section) => section.order !== 5)
            .flatMap((section) => section.fields)
            .filter((field) => field.conditions.isVisible && field.input.type !== InputType.EMPTY);
        this.fieldLabels = this.fieldNames.map((field) => field.label);
    }

    public updateReactiveParcelasLabel(label: string): void {
        const field = this.getReactiveField('ids_parcelas');

        if (field) {
            field.label = label;
        }
    }

    public getReactiveField(fieldName: string): FormField<TareaOtraModel> | undefined {
        return this.formFieldsReactive.sections
            .flatMap((section) => section.fields)
            .find((field) => field.name === fieldName);
    }

    private getHeader(): string {
        if (this.formType === FormType.EDITION) {
            return 'Actualizar Tarea';
        }

        if (this.formType === FormType.DUPLICATION) {
            return 'Duplicar Tarea';
        }

        return 'Realizar Tarea Genérica';
    }

    private getReactiveSections(): FormSection<TareaOtraModel>[] {
        const sections: FormSection<TareaOtraModel>[] = [
            {
                name: '',
                width: 12,
                isVisible: true,
                fields: this.toReactiveFields(this.formFields, 4),
                order: 1,
            },
            {
                name: '',
                width: 12,
                isVisible: true,
                fields: this.toReactiveFields(this.formFieldsLinea1, 3),
                order: 2,
            },
            {
                name: '',
                width: 12,
                isVisible: true,
                fields: this.toReactiveFields(this.formFieldsHoras, 4),
                order: 3,
            },
            {
                name: '',
                width: 12,
                isVisible: this.showTareasGenericasObservaciones,
                fields: this.toReactiveFields(this.FormFieldsObs, 12),
                order: 4,
            },
            {
                name: '',
                width: 12,
                isVisible: true,
                fields: this.getHiddenFields(),
                order: 5,
            },
        ];

        return sections.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }

    private toReactiveFields(fields: OtrasFieldMetadata[], width: number): FormField<TareaOtraModel>[] {
        return fields
            .map((field, index) => this.toReactiveField(field, index + 1, width))
            .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }

    private toReactiveField(sourceField: OtrasFieldMetadata, order: number, width: number): FormField<TareaOtraModel> {
        const name = sourceField.field ?? sourceField.name ?? '';
        const inputType = sourceField.inputType?.type ?? InputType.TEXT;
        const input: Input<TareaOtraModel> = {
            type: inputType,
            isEditable: inputType !== InputType.ONLY_TEXT,
        };
        const defaultValue = this.getDefaultValue(name, sourceField);

        if (defaultValue !== undefined) {
            input.defaultValue = defaultValue;
        }

        if (sourceField['placeholder'] !== undefined) {
            input.placeholder = sourceField['placeholder'];
        }

        if (sourceField['maxLength'] !== undefined) {
            input.maxLength = sourceField['maxLength'];
        }

        if (sourceField.values !== undefined) {
            input.data = sourceField.values as DropdownData<unknown>;
        }

        if (inputType === InputType.CALENDAR) {
            input.calendarConfiguration = sourceField['calendarConfiguration'] ?? {
                calendarView: 'date',
                calendarDateFormat: 'dd/mm/yy',
                disabledDates: this.disabledDates,
            };
        }

        if (inputType === InputType.TEXTAREA) {
            input.textAreaConfiguration = {
                ...(sourceField['rows'] !== undefined ? { rows: sourceField['rows'] } : {}),
                ...(sourceField['cols'] !== undefined ? { cols: sourceField['cols'] } : {}),
                hasVoiceTranscription: Boolean(sourceField['audio']),
                canTakePhoto: false,
                photoField: undefined,
            };
        }

        if (sourceField['mask']) {
            input.textMaskConfiguration = { mask: sourceField['mask'] };
        }

        if (this.isDropdownInput(inputType)) {
            input.dropdownConfiguration = {
                ...(sourceField.valuePrimaryKey !== undefined ? { valuePrimaryKey: sourceField.valuePrimaryKey } : {}),
                ...(sourceField['maxHeight'] !== undefined ? { hasMaxHeight: sourceField['maxHeight'] } : {}),
                ...(name === 'ids_parcelas' ? {
                    summation: {
                        summand: environment.features.hasSuperficieCultivada ? 'superficie_cultivada' : 'superficie_sigpac',
                        name: this.tipoSuperficieParcelas,
                        uds: this.textoSuperficie,
                        format: (total: number): string => total.toLocaleString('es-ES', {
                            useGrouping: true,
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        }),
                    },
                } : {}),
                ...(typeof sourceField.filter === 'function' ? {
                    filter: (it): boolean => Boolean(sourceField.filter?.(it)),
                } : {}),
            };
        }

        return {
            ...sourceField,
            name,
            field: name,
            vinculatedFields: this.getVinculatedFields(name),
            label: sourceField.label ?? '',
            input,
            width,
            conditions: this.conditions({
                isRequired: Boolean(sourceField.required),
                isVisible: sourceField.visible !== false && sourceField.hidden !== true,
            }),
            order,
        };
    }

    private getHiddenFields(): FormField<TareaOtraModel>[] {
        const fields: FormField<TareaOtraModel>[] = [
            this.createHiddenField('id', this.model.id ?? null, 1, false),
            this.createHiddenField(
                'id_cliente',
                this.getSelectedClientId(),
                2,
                true,
                ['id_finca'],
                () => this.getSelectedClientId(),
            ),
            this.createHiddenField(
                'id_usuario',
                this.model.id_usuario ?? StorageManager.getUser()?.id ?? null,
                3,
                true,
                undefined,
                () => String(this.model.id_usuario ?? StorageManager.getUser()?.id ?? ''),
            ),
            this.createHiddenField(
                'cultivo',
                this.model.cultivo ?? '',
                4,
                true,
                ['ids_parcelas'],
                () => this.getSelectedParcelas().map((it) => it.cultivo).join(';'),
            ),
            this.createHiddenField(
                'variedad',
                this.model.variedad ?? '',
                5,
                true,
                ['ids_parcelas'],
                () => this.getSelectedParcelas().map((it) => it.variedad).join(';'),
            ),
            this.createHiddenField(
                'sup_cultivada',
                this.model.sup_cultivada ?? '',
                6,
                true,
                ['ids_parcelas'],
                () => this.getSelectedParcelas().map((it) => it.superficie_cultivada).join(';'),
            ),
            this.createHiddenField('adjunto', this.model.adjunto ?? '', 7, true),
        ];

        return fields;
    }

    private createHiddenField(
        name: string,
        defaultValue: string | boolean | number | Date | TareaOtraModel | null | undefined,
        order: number,
        isRememberedOnDuplicate: boolean,
        vinculatedFields?: string[],
        updateValue?: () => string | null | undefined,
    ): FormField<TareaOtraModel> {
        return {
            name,
            field: name,
            vinculatedFields,
            label: '',
            input: {
                type: InputType.HIDDEN,
                defaultValue,
                isEditable: false,
            },
            width: 1,
            ...(updateValue ? { updateValue } : {}),
            conditions: this.conditions({ isVisible: true, isRememberedOnDuplicate }),
            order,
        };
    }

    private getDefaultValue(
        name: string,
        sourceField: OtrasFieldMetadata,
    ): string | boolean | number | Date | TareaOtraModel | null | undefined {
        const modelValue = (this.model as Record<string, string | boolean | number | Date | TareaOtraModel | null | undefined>)[name];

        if (modelValue !== undefined) {
            return modelValue;
        }

        const defaultValue = sourceField['defaultValue'] as string | boolean | number | Date | TareaOtraModel | null | undefined;

        return defaultValue ?? null;
    }

    private getSelectedClientId(): string | null {
        const selectedFinca = this.fincas.selected as FincasModel | null | undefined;

        return String(selectedFinca?.id_cliente ?? this.model.id_cliente ?? StorageManager.getClient()?.id ?? '');
    }

    private getSelectedParcelas(): ParcelasModel[] {
        const selectedItems = this.getRawSelectedParcelas(this.parcelas.selected);

        if (selectedItems.length > 0) {
            return selectedItems;
        }

        const selectedIds = this.getSelectedIds(this.parcelas.selected, this.model.ids_parcelas);

        if (selectedIds.length === 0) {
            return [];
        }

        return this.parcelas.values
            .map((option) => option.value)
            .filter((value): value is ParcelasModel => value != null && selectedIds.includes(String(value.id ?? '')));
    }

    private getRawSelectedParcelas(rawValue: unknown): ParcelasModel[] {
        const rawItems = Array.isArray(rawValue) ? rawValue : [rawValue];

        return rawItems.filter((item): item is ParcelasModel => this.isParcelaModel(item));
    }

    private isParcelaModel(value: unknown): value is ParcelasModel {
        return typeof value === 'object' && value !== null && 'id' in value;
    }

    private isDropdownInput(inputType: InputType): boolean {
        return [
            InputType.DROPDOWN,
            InputType.DROPDOWN_SEARCH,
            InputType.MULTISELECT_SEARCH,
            InputType.MULTISELECT,
        ].includes(inputType);
    }

    private getVinculatedFields(fieldName: string): string[] | undefined {
        const dependencies: Record<string, string[]> = {
            id_finca: ['id_cliente'],
            id_sector: ['id_finca'],
            ids_parcelas: ['id_finca', 'id_sector'],
            horas_totales: ['hora_inicio', 'hora_fin'],
        };

        return dependencies[fieldName];
    }

    private conditions(overrides: Partial<FormFieldConditions> = {}): FormFieldConditions {
        return {
            isRememberedOnDuplicate: true,
            isRequired: false,
            isRetained: false,
            hasUndoEnabled: false,
            isVisible: true,
            ...overrides,
        };
    }


    private filterFinca(it: FilteredValue<FincasModel>): boolean {
        const finca = it.value;

        if (finca == null) {
            return true;
        }

        const selectedClientIds = this.getSelectedIds(this.clientes.selected);

        if (selectedClientIds.length === 0) {
            return true;
        }

        return selectedClientIds.includes(String(finca.id_cliente ?? ''));
    }

    private filterSector(it: FilteredValue<SectorModel>): boolean {
        const sector = it.value;

        if (sector == null) {
            return true;
        }

        const selectedFincaIds = this.getSelectedIds(this.fincas.selected, this.model.id_finca);

        if (selectedFincaIds.length === 0) {
            return false;
        }

        return selectedFincaIds.includes(String(sector.id_finca ?? ''));
    }

    private filterParcela(it: FilteredValue<ParcelasModel>): boolean {
        const parcela = it.value;

        if (parcela == null) {
            return true;
        }

        if (parcela.activo?.toString() !== '1' && this.appName !== 'ava') {
            return false;
        }

        const selectedSectorIds = this.getSelectedIds(this.sectores.selected, this.model.id_sector);

        if (selectedSectorIds.length > 0) {
            return selectedSectorIds.includes(String(parcela.id_sector ?? ''));
        }

        const selectedFincaIds = this.getSelectedIds(this.fincas.selected, this.model.id_finca);

        if (selectedFincaIds.length === 0) {
            return false;
        }

        return selectedFincaIds.includes(String(parcela.id_finca ?? ''));
    }

    private getSelectedIds(...values: unknown[]): string[] {
        return values
            .flatMap((value) => this.getIdsFromValue(value))
            .filter((value, index, array) => value.length > 0 && array.indexOf(value) === index);
    }

    private getIdsFromValue(value: unknown): string[] {
        if (Array.isArray(value)) {
            return value.flatMap((item) => this.getIdsFromValue(item));
        }

        if (value === null || value === undefined || value === '') {
            return [];
        }

        if (typeof value === 'object') {
            const id = (value as { id?: string | number | null }).id;

            return id === null || id === undefined || id === '' ? [] : [String(id)];
        }

        return String(value)
            .split(';')
            .map((item) => item.trim())
            .filter((item) => item.length > 0);
    }

    public esViveroOGardenGest() {
        if (this.serveUrl.indexOf('gardengest') !== -1 || this.serveUrl.indexOf('viverogest') !== -1) {
            return true;
        } else {
            return false;
        }
    }
}


